import { GoogleOAuthProvider } from "@react-oauth/google";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import AuthContext from "./AuthContext";
import store from "./redux/store";
import * as serviceWorker from "./serviceWorker";
import { CustomApolloProvider } from "./apollo/CustomApolloProvider";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <GoogleOAuthProvider clientId="416863625326-bt3sf5pgkl3rb77da171a1htrhl7lg83.apps.googleusercontent.com">
    <CustomApolloProvider>
      <Provider store={store}>
        <AuthContext.Provider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthContext.Provider>
      </Provider>
    </CustomApolloProvider>
  </GoogleOAuthProvider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
